import {HostDetails} from './HostDetails/HostDetails';
import {HostMessage} from './HostMessage';

export const DetailsModule = () => (
  <div className="view-invitation__event-info" id="event-details">
    <HostDetails />
    <HostMessage />
  </div>
);
